// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"ImednetSchedule2Form__wrapper__nR4gw","submitResult":"ImednetSchedule2Form__submitResult__3tl59","actionWrapper":"ImednetSchedule2Form__actionWrapper__ZYD7O","activateWrap":"ImednetSchedule2Form__activateWrap__1P_IY","wrapper2faOptions":"ImednetSchedule2Form__wrapper2faOptions__3iyZY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ImednetSchedule2Form/ImednetSchedule2Form.css
// module id = 3068
// module chunks = 0